import { Col, Container, Image, Row } from 'react-bootstrap';
import ReactPlayer from 'react-player/lazy';

import React from 'react';

export default function Header() {
  return (
    <Container fluid id="header-wrapper">
      {/* <Row className="justify-content-center">
        <Col xs={8} md={5} lg={4}>
          <Image
            src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
            fluid
            alt="Sun West Mortgage Logo"
          />
        </Col>
      </Row> */}
     
      <Row className="justify-content-center header-d">
        <Col md={12} lg={8} xl={6}>
        <h2 className="pt-3 text-center ">
        Your local family owned lender that shares your values.
</h2>
          <div className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://youtu.be/ptbzl6MXbKU"
              width="100%"
              height="100%"
              light="./img/banner-ivan-pavan-conversation.png"
              playing
              controls
            />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center pt-4">
        <Col md={12} lg={8} xl={6}>
          <div className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=cEe5CIwFvDs"
              width="100%"
              height="100%"
              light="./img/sunwest-dna.png"
              playing
              controls
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
